<div class="container">
  <header class="header-between">
    <app-logo class="logo-pages"></app-logo>
    <app-search-bar></app-search-bar>
  </header>

  <section>
    <app-profile [state]="state"></app-profile>
    <div>
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
